import React, { useState } from 'react';
import { useKeycloakAuth } from '../../contexts/KeycloakAuthProvider';
import { useNotificationService } from '../Notification';
import { Logo } from '../common';

export const LoginForm: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useKeycloakAuth();
  const { showSuccess, showError } = useNotificationService();

  const handleMicrosoftLogin = async () => {
    setIsLoading(true);
    try {
      // Simulate Microsoft SSO API call
      await new Promise((resolve) => setTimeout(resolve, 1500));

      // Đăng nhập thành công
      login();

      // Show success notification
      setTimeout(() => {
        showSuccess('Thành công', 'Đăng nhập Microsoft thành công!');
      }, 100);
    } catch (error) {
      console.error('Microsoft login error:', error);
      showError('Lỗi', 'Đăng nhập Microsoft thất bại. Vui lòng thử lại.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='text-center'>
      <div className='mb-8'>
        <h1 className='mb-4 flex items-center justify-center text-3xl font-bold text-white drop-shadow-lg'>
          <Logo className='text-white drop-shadow-lg' />
        </h1>
        <p className='text-white/80 drop-shadow'>Sử dụng tài khoản Microsoft của bạn để đăng nhập</p>
      </div>

      <button
        onClick={handleMicrosoftLogin}
        disabled={isLoading}
        className='flex w-full transform items-center justify-center rounded-lg border border-white/10 bg-white/5 px-6 py-4 font-medium text-white shadow-lg backdrop-blur-sm transition-all duration-300 hover:scale-105 hover:bg-white/15 hover:shadow-xl disabled:cursor-not-allowed disabled:opacity-50'
      >
        {isLoading ? (
          <div className='flex items-center'>
            <div className='mr-3 h-5 w-5 animate-spin rounded-full border-b-2 border-white'></div>
            Đang đăng nhập...
          </div>
        ) : (
          <>
            <svg className='mr-3 h-6 w-6' viewBox='0 0 24 24'>
              <path fill='#F25022' d='M1 1h10v10H1z' />
              <path fill='#00A4EF' d='M13 1h10v10H13z' />
              <path fill='#7FBA00' d='M1 13h10v10H1z' />
              <path fill='#FFB900' d='M13 13h10v10H13z' />
            </svg>
            Đăng nhập với Microsoft
          </>
        )}
      </button>
    </div>
  );
};
